import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { listen, onError } from '@chegg/one-auth-sdk';
import { EventTypes, recordEvents } from "../utils/newRelicEvents";
var callback = null;
export function register(cb) {
  if (callback) {
    return;
  }
  callback = cb;
  listen('tokens', function (payload, actionDetail) {
    cb({
      type: 'auth',
      payload: {
        action: 'login',
        status: 'success',
        data: payload,
        actionDetail: actionDetail
      }
    });
  });
  onError(function (_ref) {
    var scope = _ref.scope,
      error = _ref.error;
    if (scope == 'login') {
      cb({
        type: 'auth',
        payload: {
          action: 'login',
          status: 'error',
          data: {
            error: error
          }
        }
      });
    }
    if (error.criticalError) {
      var _error$response;
      recordEvents(_defineProperty({}, EventTypes.unknownError, {
        //@ts-ignore
        status: (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) || 'unknown',
        apiName: error.apiName,
        message: error.message
      }));
    }
  });
}
export function unregister() {
  callback = null;
}
export function trigger(args) {
  if (!callback) {
    return;
  }
  callback(args);
}